/**
 * Validates that the user has signed and has a valid RFC
 *
 * @param {*} sign
 * @param {*} currentRFC
 * @return {*}
 */
export const handleValidateAuthorization = (sign, currentRFC) => {
    const validations = {
        sign: null,
        rfc: null,
    };

    if (!sign)
        validations.sign =
            'La firma es requerida para poder hacer la solicitud';

    if (currentRFC.length !== 13)
        validations.rfc = 'El RFC debe tener una longitud de 13 caracteres';

    return {
        validations,
        response: Object.values(validations).every((v) => v === null),
    };
};
